import { identity } from 'lodash';

/**
 * Removes nested properties `oldProp` from `object`, and replaces them with
 *  `newProp`, with value derived from `convert()`, given the value
 *  from `oldProp`.
 *
 * **NB: Mutates `object`.**
 * @param {any} object
 * @param {string | RegExp | (prop: string) => boolean} oldProp
 * @param {string | (oldProp: string) => string} newProp
 * @param {(prev: any, oldProp: string, newProp: string) => any} convert
 * @returns {object}
 */
export default function convertPropertiesDeep(object, oldProp, newProp, convert = identity) {

    for (const prop of Object.keys(object)) {

        // Check prop either via string comparison, or with predicate
        const shouldConvert = (
            typeof oldProp === 'function' ? oldProp(prop)
                : oldProp instanceof RegExp ? oldProp.test(prop)
                : oldProp === prop
        );

        if (shouldConvert) {
            const oldValue = object[prop];
            delete object[prop];

            const finalNewProp = (
                typeof newProp === 'function' ? newProp(prop)
                    : newProp
            );

            object[finalNewProp] = convert(oldValue, prop, finalNewProp);
        }
        else {
            const value = object[prop];

            if (value && typeof value === 'object') {
                convertPropertiesDeep(value, oldProp, newProp, convert);
            }
        }
    }

    return object;
}